module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appointmentPresentation"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue",
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("我要预约")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.ewmImg
    }
  }), _vm._v(" "), _vm._m(1, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_vm._v("长按识别二维码"), _c('br'), _vm._v("关注“"), _c('span', {
    staticStyle: {
      "color": "#4ba7e8"
    }
  }, [_vm._v("JXR武汉锦欣中西医结合妇产医院")]), _vm._v("”微信公众号"), _c('br'), _vm._v("进行预约！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerPromt"
  }, [_vm._v("如有疑问，请联系客服："), _c('a', {
    staticStyle: {
      "color": "#4ba7e8"
    },
    attrs: {
      "href": "tel:02782889968"
    }
  }, [_vm._v("027-82889968")]), _vm._v("，感谢您的支持！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4d68a2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/articleProject/appointmentPresentation.vue
// module id = Xme+
// module chunks = 7